import React, { useState } from "react";
import { useDebounce } from "use-debounce";
import { message } from "antd";
import {
  useProductionsQuery,
  useProductsQuery,
  useRawMaterialsQuery,
  useRecipeQuery,
  useCreateProductionMutation,
} from "../../../Services";
import { PAGE_SIZE, DEBOUNCED_SEARCH_QUERY } from "../../../Constant";
import { Production } from "../../../Types";

export function useProductionData(page: number, search: string) {
  const { data, isLoading, refetch } = useProductionsQuery({
    page,
    limit: PAGE_SIZE,
    search,
  });

  return {
    productions: (data || []) as Production[],
    total: data?.total || 0,
    isLoading,
    refetch,
  };
}

export function useProductLookup() {
  const [productSearch, setProductSearch] = useState("");
  const [debouncedSearch] = useDebounce(productSearch, DEBOUNCED_SEARCH_QUERY);

  const { data } = useProductsQuery({
    page: 1,
    limit: 50,
    search: debouncedSearch,
  });

  return { products: data?.data || [], setProductSearch };
}

export function useRawMaterials() {
  const { data } = useRawMaterialsQuery({ page: 1, limit: 200 });
  return data?.data || [];
}

export function useRecipe(productId: string | null) {
  const { data, isLoading } = useRecipeQuery(productId || undefined, {
    enabled: !!productId,
  });
  return { recipe: data ?? null, recipeLoading: isLoading };
}

export function useCreateProduction(onSuccess: () => void) {
  const createMutation = useCreateProductionMutation();

  return {
    mutate: (payload: any) => {
      createMutation.mutate(payload, {
        onSuccess: (res) => {
          if (res?.success) {
            message.success("Production recorded. Stock levels updated.");
            onSuccess();
          } else {
            message.error(res?.message || "Failed to create production.");
          }
        },
        onError: () => {
          message.error("An error occurred while creating the production.");
        },
      });
    },
    isPending: createMutation.isPending,
  };
}
